// extracted by mini-css-extract-plugin
module.exports = {"slideshow":"p_bB","view":"p_bC","slide":"p_bD","img":"p_bF","btn":"p_bG","right":"p_bH","indicators":"p_bJ","indicator":"p_bK","active":"p_bL"};